import { render, staticRenderFns } from "./partner-join.vue?vue&type=template&id=0013773e&scoped=true&lang=pug&"
import script from "./partner-join.vue?vue&type=script&lang=js&"
export * from "./partner-join.vue?vue&type=script&lang=js&"
import style0 from "./partner-join.vue?vue&type=style&index=0&id=0013773e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0013773e",
  null
  
)

export default component.exports